import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { isTestServer } from "../../../core/utils/environment.util";

@Component({
  selector: "app-test-server-banner",
  templateUrl: "./test-server-banner.component.html",
  styleUrls: ["./test-server-banner.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TestServerBannerComponent implements OnInit, OnDestroy {
  readonly isTestServer = isTestServer();

  ngOnInit(): void {
    if (this.isTestServer) {
      document.body.classList.add("has-test-server-banner");
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove("has-test-server-banner");
  }
}
